import React from 'react';
import { useTranslation, Trans, TransProps } from 'react-i18next';

export const Translate = (props: TransProps<string>) => {
  const { t } = useTranslation();
  return <Trans t={t} {...props} />;
};
